import React from 'react';
import Button from '../../../components/ui/Button';

const ActionButtons = ({ onSave, onCancel, isSaving, hasChanges }) => {
  return (
    <div className="flex items-center justify-between p-6 border-t border-border bg-card">
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onCancel}
          disabled={isSaving}
        >
          Cancel
        </Button>
      </div>

      <div className="flex items-center gap-2">
        {hasChanges && (
          <span className="text-xs text-warning-foreground bg-warning/20 px-3 py-1 rounded-full border border-warning/30">
            Unsaved changes
          </span>
        )}
        <Button
          variant="default"
          size="sm"
          onClick={onSave}
          loading={isSaving}
          disabled={!hasChanges}
          iconName="Save"
          iconPosition="left"
        >
          Save Changes
        </Button>
      </div>
    </div>
  );
};

export default ActionButtons;